// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__22Eoa","text":"SelectPayment_text__2UwhO","title":"SelectPayment_title__2y7yN","btn":"SelectPayment_btn__2XRRU"};